import React from "react";
import styles from "./styles";
import TagsList from "../TagsList";
import ToolsList from "../ToolsList";
import ActionsList from "../ActionsList";

export const PostHeaderContent = ({ post }) => {
  return (
    <>
      <div className="content-header">
        <div className="content-title-wrapper">
          <h1 className="content-title">{post.data?.title}</h1>
          <TagsList post={post} />
          <ActionsList video={post.data?.video.url} title={post?.data?.title} />
        </div>
        {post?.data?.tools_needed.length > 0 && <ToolsList post={post} />}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default PostHeaderContent;
